<div class="container-fluid m-0 p-0 mt-3 bg-warning border-bottom border-light-subtle shadow-sm">
    <div class="row m-0 p-0">
        <div class="col m-0 py-2 px-3">
            <h3 class="m-0 p-0 font-monospace" [innerHTML]="pageTitle"></h3>
        </div>
    </div>
</div>